import React from 'react'

import { ComposerSettings } from '~/types'

interface Props {
  settings: ComposerSettings
}

const SettingsStateContext = React.createContext<Props['settings'] | undefined>(
  undefined
)

export const SettingsProvider: React.FC<Props> = (props) => {
  return (
    <SettingsStateContext.Provider value={props.settings}>
      {props.children}
    </SettingsStateContext.Provider>
  )
}

export function useSettings() {
  const contextValue = React.useContext(SettingsStateContext)
  if (contextValue === undefined) {
    throw new Error('useSettingsState must be used within a SettingsProvider')
  }
  return contextValue
}
